// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkboxWithTextContainer_riq2D {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  font-family: "Inter", sans-serif;
  margin-top: 2px;
}

.text_WS4B3 {
  color: var(--292a2b-color);
  font-size: 11px;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/CheckboxWithText/CheckboxWithText.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n.checkboxWithTextContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 5px;\n  font-family: \"Inter\", sans-serif;\n  margin-top: 2px;\n}\n\n.text {\n  color: var(--292a2b-color);\n  font-size: 11px;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxWithTextContainer": `checkboxWithTextContainer_riq2D`,
	"text": `text_WS4B3`
};
export default ___CSS_LOADER_EXPORT___;
